import { BACKEND_URL } from "../env";

export type GenerateDebugMagicLinkInput = {
  clientId: string;
  userEmail: string;
};

export type GeneratedDebugMagicLink = {
  url: string;
  expiresAt: string;
};

export async function generateDebugMagicLink(
  input: GenerateDebugMagicLinkInput
): Promise<GeneratedDebugMagicLink> {
  const response = await fetch(`${BACKEND_URL}/magic-links/admin/generate`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });

  if (response.status >= 400) {
    throw new Error(`generateDebugMagicLink failed: ${response.status}`);
  }

  return response.json() as Promise<GeneratedDebugMagicLink>;
}
